import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Camera } from 'assets/svg/camera-line.svg';

export const ImageUpload = props => {
  let fileRef;

  const pickFile = () => {
    fileRef.click();
  };

  return (
    <div className="image-upload">
      <div className="image-upload__container" onClick={pickFile}>
        <input
          type="file"
          name=""
          id=""
          onChange={props.onChange}
          accept="image/*"
          ref={ref => {
            fileRef = ref;
          }}
        />
        {props.preview.length ? <img src={props.preview} alt="avatar" /> : null}
        <Camera width={37} height={30} className="image-upload__icon" />
      </div>
    </div>
  );
};

ImageUpload.defaultProps = {
  preview: ''
};

ImageUpload.propTypes = {
  onChange: PropTypes.func,
  preview: PropTypes.string
};
